import * as React from 'react';

import _ from 'underscore';

import {FloatingLabelTextField} from 'shells/floating-label-textfield/floating-label-textfield';

import {SearchResults} from './search-results';
import {SidebarDrawer} from './sidebar-drawer';

import styles from './sidebar-search.module.css';

type Props = {
    closeSidebar: () => void;
};
type State = {
    value: string;
    debouncedSearchVal: string;
    isFakeSearching: boolean;
};

export class SidebarSearch extends React.PureComponent<Props, State> {
    searchField: HTMLElement | null | undefined;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            value: '',
            debouncedSearchVal: '',
            isFakeSearching: false,
        };
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.searchField) {
                this.searchField.focus();
            }
        }, 200);
    }

    render() {
        return (
            <SidebarDrawer customHeader={this.renderSearchBarHeader()}>
                <SearchResults
                    isFakeSearching={this.state.isFakeSearching}
                    query={this.state.debouncedSearchVal}
                    closeSidebar={this.props.closeSidebar}
                />
            </SidebarDrawer>
        );
    }

    renderSearchBarHeader() {
        return (
            <div className={styles['search-field']}>
                <FloatingLabelTextField
                    value={this.state.value}
                    name='search-everything'
                    autoFocus={false}
                    textFieldRef={(node) => {
                        this.searchField = node;
                    }}
                    label='Search everything…'
                    onChange={this.handleSearchChange}
                />
            </div>
        );
    }

    handleSearchChange = (debouncedSearchVal: string) => {
        this.setState({
            value: debouncedSearchVal,
            isFakeSearching: true,
        });
        this.updateSearchQueryDebounced(debouncedSearchVal);
    };

    updateSearchQueryDebounced = _.debounce((debouncedSearchVal: string) => {
        this.setState({
            debouncedSearchVal: debouncedSearchVal,
            isFakeSearching: false,
        });
    }, 250);
}
